import * as React from 'react';
import { Text, View } from 'react-native';

import { getLocalizedTexts } from '../../../Locales';
import color from '../../../style/color';
import { styles } from './Styles';

// "Version B" (GRW-252) stepper used by the vertical instruction screens: the active section is a black
// rounded pill with white text, the inactive section is greyed-out plain text, joined by a thin connector
// bar. The connector turns black once the preceding step is completed (i.e. on the authorization step).
export function VerticalStepper({
    currentStep,
    labels,
}: {
    currentStep: number;
    labels?: { left: string; right: string };
}) {
    const texts = getLocalizedTexts().mobileSafariExtensionInstallationPagesRevamped.header;
    const left = labels?.left ?? texts.left;
    const right = labels?.right ?? texts.right;
    return (
        <View style={styles.containerVerticalStepper}>
            <VerticalStepperLabel label={left} isActive={currentStep === 0} />
            <View
                style={[
                    styles.verticalStepperConnector,
                    { backgroundColor: currentStep === 1 ? color.black : color.alto },
                ]}
            />
            <VerticalStepperLabel label={right} isActive={currentStep === 1} />
        </View>
    );
}

function VerticalStepperLabel({ label, isActive }: { label: string; isActive: boolean }) {
    if (!isActive) return <Text style={styles.verticalStepperLabelText}>{label}</Text>;
    return (
        <View style={styles.verticalStepperPillActive}>
            <Text style={[styles.verticalStepperLabelText, styles.verticalStepperLabelTextActive]}>{label}</Text>
        </View>
    );
}
